var map = {
	"./Adjustment.png": 96908,
	"./Beneficiary.png": 23542,
	"./Card refunds.png": 50406,
	"./Chargeback.png": 72884,
	"./Client.png": 68612,
	"./Debit voucher.png": 64309,
	"./Duplicate.png": 49998,
	"./Field force.png": 6124,
	"./Income.png": 52828,
	"./InstantPay card icon.png": 53083,
	"./InstantPay.png": 78054,
	"./Internal arrow.png": 72685,
	"./Internal.png": 64490,
	"./MIS report.png": 13692,
	"./Netbanking refunds.png": 90709,
	"./Nodal.png": 40561,
	"./Nothing.png": 7526,
	"./Payment advice.png": 10051,
	"./Reimbursement.png": 26805,
	"./Select pink.png": 57481,
	"./Transaction initiation email.png": 77647,
	"./Transaction links.png": 68046,
	"./UPI refunds.png": 83848,
	"./Vendor.png": 40975,
	"./Xpentra.png": 91033,
	"./announcement-grey.png": 74722,
	"./arrow_down_red.png": 63727,
	"./arrow_next.png": 81380,
	"./arrowdown_filled.png": 79459,
	"./arrowup_filled.png": 49186,
	"./beneficiary_account_with_blue_circle.svg": 44667,
	"./beneficiary_transaction_with_blue_circle.svg": 17160,
	"./browse_file.png": 81958,
	"./cancel.png": 92599,
	"./internal_transaction_with_blue_circle.svg": 7598,
	"./ip_cropped.png": 19530,
	"./owner_accounts_with_blue_circle.svg": 94556,
	"./reminders-grey.png": 41814,
	"./select_all_with_white_filled_circle.png": 77146,
	"./selected_with_green_circle.png": 18836,
	"./settings-active.png": 23775,
	"./settings-grey.png": 69100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11285;